// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605010147/js/" + chunkId + "." + {"44":"26991971","225":"06dd8ab4","481":"0e88fe87","486":"e516a4bf","770":"4dd83620"}[chunkId] + ".0.31494510478651017.chunk.js";
};